import { createActions } from 'redux-actions';

export const weatherActions = createActions({
    GET_WEATHER:         (entityType, entityID, queryParams, displayMachine) => ({ entityType, entityID, queryParams, displayMachine }),
    GET_WEATHER_SUCCESS: (key, weather) => ({ key, weather }),
    GET_WEATHER_FAIL:    (error) => error,
});
